export interface StoryForestImageAsset {
  key: string;
  path: string;
}

export const STORY_FOREST_ASSETS = {
  arrivalBackground: {
    key: 'story-forest-arrival-background',
    path: 'assets/story-forest/backgrounds/story-forest-arrival-bg.png',
  },
  foregroundFoliageLeft: {
    key: 'story-forest-foreground-foliage-left',
    path: 'assets/story-forest/environments/foreground-foliage-left.png',
  },
  foregroundFoliageRight: {
    key: 'story-forest-foreground-foliage-right',
    path: 'assets/story-forest/environments/foreground-foliage-right.png',
  },
  storyTreeDormant: {
    key: 'story-forest-story-tree-dormant',
    path: 'assets/story-forest/story-tree/story-tree-dormant.png',
  },
  storyTreeAwakened: {
    key: 'story-forest-story-tree-awakened',
    path: 'assets/story-forest/story-tree/story-tree-awakened.png',
  },
  storyLantern: {
    key: 'story-forest-story-lantern',
    path: 'assets/story-forest/interactives/story-lantern.png',
  },
  storyTrailMarker: {
    key: 'story-forest-story-trail-marker',
    path: 'assets/story-forest/interactives/story-trail-marker.png',
  },
  storyEventToken: {
    key: 'story-forest-story-event-token',
    path: 'assets/story-forest/interactives/story-event-token.png',
  },
  storyEventSlot: {
    key: 'story-forest-story-event-slot',
    path: 'assets/story-forest/interactives/story-event-slot.png',
  },
  storyEventSlotActive: {
    key: 'story-forest-story-event-slot-active',
    path: 'assets/story-forest/interactives/story-event-slot-active.png',
  },
  storyMissionPanel: {
    key: 'story-forest-story-mission-panel',
    path: 'assets/story-forest/ui/story-mission-panel.png',
  },
  storyMagicVfx: {
    key: 'story-forest-story-magic-vfx',
    path: 'assets/story-forest/vfx/story-magic-vfx.png',
  },
  storyForestCosmo: {
    key: 'story-forest-cosmo',
    path: 'assets/shared/cosmo/cosmo-story-forest.png',
  },
} as const satisfies Record<string, StoryForestImageAsset>;

export const STORY_FOREST_ASSET_LIST = Object.values(STORY_FOREST_ASSETS);
export const STORY_FOREST_PRODUCTION_READY: boolean = true;

export function preloadStoryForestAssets(scene: Phaser.Scene) {
  if (!STORY_FOREST_PRODUCTION_READY) return;
  STORY_FOREST_ASSET_LIST
    .filter(asset => !scene.textures.exists(asset.key))
    .forEach(asset => scene.load.image(asset.key, asset.path));
}

export function hasStoryForestProductionAssets(scene: Phaser.Scene) {
  return STORY_FOREST_PRODUCTION_READY
    && STORY_FOREST_ASSET_LIST.every(asset => scene.textures.exists(asset.key));
}

export function getMissingStoryForestAssets(scene: Phaser.Scene) {
  return STORY_FOREST_ASSET_LIST.filter(asset => !scene.textures.exists(asset.key));
}
